import Input from "shared/Input/Input";
import React, { useState, ChangeEvent, FC, useEffect } from "react";
import { useData } from "data/data-provider";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { ProfileChangeFun } from "api/profile/profile";
import toast from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import { AddCustomer } from "api/customer/customer";
import { globalJson } from "global/global_json";
import { tripModificationRequest } from "api/booking/booking";

interface RenterInfoProp {
  bookingDetails: any;
}

const DriverInfo: FC<RenterInfoProp> = ({ bookingDetails }) => {
  const {
    driverEmail,
    driverFirstName,
    driverLastName,
    driverPhone,
    setDriverEmail,
    setDriverFirstName,
    setDriverLastName,
    setDriverPhone,
  } = useData();
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const clearError = (field: string) => {
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[field];
      return updatedErrors;
    });
  };

  //   useEffect(() => {
  //     setDriverFirstName(bookingDetails?.customer?.first_name);
  //     setDriverLastName(bookingDetails?.customer?.last_name);
  //     setDriverEmail(bookingDetails?.customer?.driverEmail);
  //     const rawPhone = bookingDetails?.customer?.phone_no || "";
  //     if (rawPhone) {
  //       let formattedPhone = rawPhone.startsWith("+") ? rawPhone : `+${rawPhone}`;
  //       setDriverPhone(formattedPhone); // Set  driverPhone with international format
  //     }
  //   }, []);

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};
    if (!driverFirstName) newErrors.driverFirstName = "First Name is required";
    if (!driverLastName) newErrors.driverLastName = "Last Name is required";
    if (
      !driverEmail ||
      !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(driverEmail)
    ) {
      newErrors.driverEmail = "Please enter a valid  driverEmail address";
    }
    if (!driverPhone || driverPhone?.length < 10) {
      newErrors.driverPhone = "Please enter a valid  driverPhone number";
    }
    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const AddDriverInfo = async () => {
    if (!validateForm()) {
      toast.error("Please fill in the correct details");
      return;
    }
    if(bookingDetails?.customer?.email=== driverEmail){
      toast.error("Customer and secondary driver email cannot be same")
      return;
    }
    const payload = {
      company:
        process.env.REACT_APP_ENV !== "prod"
          ? globalJson.dev_company_id
          : globalJson.prod_company_id,
      first_name: driverFirstName,
      last_name: driverLastName,
      email: driverEmail,
      phone_no: driverPhone.replace(/\D/g, ""),
    };
    try {
      const response = await AddCustomer(payload);
      if (response.error) {
        toast.error(response.error);
        return;
      }

      if (response.data) {
        const payload = {
          booking: bookingDetails?.id,
          secondary_driver: response.data.id,
        };
        try {
          const result = await tripModificationRequest(payload);
          if (!result.error) {
            toast.success("Secondary Driver Added successfully");
          } else {
            toast.error(result.error);
          }
        } catch (err) {
          toast.error("An error occurred while processing your request.");
        }
      }
    } catch {
      toast.error("An error occurred while processing your request.");
    }
  };

  return (
    <div className=" flex flex-col sm:rounded-2xl sm:space-y-8 pb-10 px-0 sm:p-4 xl:p-8 !space-y-6 mt-4">
      {" "}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <Input
            placeholder="John"
            value={driverFirstName}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              setDriverFirstName(e.target.value);
              if (e.target.value) clearError(" driverFirstName"); // Clear error if input is valid
            }}
          />

          {errors.driverFirstName && (
            <span className="text-red-500 text-xs font-semibold">
              {errors.driverFirstName}
            </span>
          )}
        </div>
        <div>
          <Input
            placeholder="Doe"
            value={driverLastName}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              setDriverLastName(e.target.value);
              if (e.target.value) clearError("  driverLastName");
            }}
          />

          {errors.driverLastName && (
            <span className="text-red-500 text-xs font-semibold">
              {errors.driverLastName}
            </span>
          )}
        </div>
        <div>
          <Input
            placeholder="Johndoe@gmail.com"
            type="email"
            value={driverEmail}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              setDriverEmail(e.target.value);
              if (
                /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(
                  e.target.value
                )
              ) {
                clearError(" driverEmail");
              }
            }}
          />

          {errors.driverEmail && (
            <span className="text-red-500 text-xs font-semibold">
              {errors.driverEmail}
            </span>
          )}
        </div>
        <div>
          <PhoneInput
            country={"us"}
            value={driverPhone}
            onChange={(driverPhone) => {
              setDriverPhone(driverPhone);
              if (driverPhone?.length >= 10) clearError(" driverPhone");
            }}
            inputProps={{
              name: "driverPhone",
              required: true,
              autoFocus: true,
            }}
            inputStyle={{
              border: "none",
              width: "100%",
              minHeight: "44px",
              boxShadow: "none",
              background: "transparent",
            }}
            buttonStyle={{
              background: "transparent",
              border: "none",
            }}
          />

          {errors.driverPhone && (
            <span className="text-red-500 text-xs font-semibold ">
              {errors.driverPhone}
            </span>
          )}
        </div>
      </div>
      <div className="flex  justify-center">
        <ButtonPrimary onClick={AddDriverInfo}>Add Driver</ButtonPrimary>
      </div>
    </div>
  );
};

export default DriverInfo;
